<template>
  <b-modal
    id="create-baseline-modal"
    name="create-baseline-modal"
    title="Create a baseline"
    ref="createbaselinemodal"
    size="lg"
    :busy="loading"
    ok-title="Create"
    :ok-disabled="!baselineName"
    close-title="Cancel"
    hide-header-close
    @shown="shown"
    @cancel="handleCancel"
    @ok="handleOk">
    <form id="create-baseline-form">
      <div class="form-group">
        <b-form-input type="text"
                      id="baseline-name"
                      placeholder="Baseline name"
                      v-model="baselineName"
                      data-vv-name="name"
                      v-validate="'required'">
        </b-form-input>
        <icon v-show="errors.has('name')" name="warning"></icon>
        <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span>
      </div>
      <div class="form-group">
        <b-form-textarea v-model="baselineDescription"
                         placeholder="Description"
                         :rows="2"
                         :max-rows="6">
        </b-form-textarea>
      </div>
      <div class="form-group">
        <b-form-group>
          <b-form-radio-group id="radios2"
                              v-model="selectRequirementsOption"
                              stacked>
            <b-form-radio :value="'all'">Baseline all requirements in this project</b-form-radio>
            <b-form-radio :value="'folder'">Baseline all requirements in a folder</b-form-radio>
            <folders-list v-if="selectRequirementsOption === 'folder'" :folders="folders"></folders-list>
            <b-form-radio :value="'individual'">Select individual requirements in this project to baseline</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <multiselect v-model="selectedRequirements"
                     v-if="selectRequirementsOption === 'individual'"
                     :options="requirements"
                     :multiple="true"
                     :custom-label="customRequirementLabel"
                     :close-on-select="true"
                     :clear-on-select="false"
                     :hide-selected="true"
                     placeholder="Select requirement(s)"
                     label="name"
                     track-by="requirement_id">
        </multiselect>
      </div>
      <span>This will be added to project <strong>{{ currentProject.name }}</strong></span>
    </form>
    <div slot="modal-ok" v-if="loading">
      <icon name="spinner" pulse></icon> Creating
    </div>
  </b-modal>
</template>

<script>
  import dialogMixin from '@/mixins/dialog'
  import utilsMixin from '@/mixins/utils'
  import FoldersList from '@/components/FoldersList'
  export default {
    components: { FoldersList },
    computed: {
      currentProject () {
        return this.$store.state.currentProject
      },
      selectedFolder () {
        return this.$store.state.selectedFolder
      }
    },
    data () {
      return {
        baselineName: '',
        baselineDescription: '',
        loading: false,
        folders: [],
        requirements: [],
        selectRequirementsOption: 'all',
        selectedRequirements: []
      }
    },
    mixins: [dialogMixin, utilsMixin],
    methods: {
      handleOk (e) {
        e.preventDefault()
        // This validateAll is needed for the case when nothing has been entered yet
        // Otherwise it was letting it validate
        // The empty then/catch avoids a console error
        this.$validator.validateAll().then(() => {
        }).catch(() => {
        })
        if (this.errors.any()) {
          return e.cancel()
        } else {
          this.loading = true
          this.submitData()
        }
      },
      handleCancel (e) {
        this.clearModal()
      },
      shown () {
        this.getRequirements()
        this.getPrimaryFolders()
      },
      clearModal () {
        this.baselineName = ''
        this.baselineDescription = ''
        this.loading = false
        this.selectedRequirements = []
        this.selectRequirementsOption = 'all'
        this.$store.commit('setSelectedFolder', null)
        this.$nextTick(() => {
          this.errors.clear()
        })
      },
      customRequirementLabel (requirement) {
        /* eslint-disable camelcase */
        const idToShow = requirement.display_id ? requirement.display_id : requirement.requirement_id
        return `${requirement.prefix}${idToShow}: ${requirement.name}`
        /* eslint-enable camelcase */
      },
      submitData () {
        this.$ga.event('baseline', 'create', this.selectRequirementsOption, 1)
        this.$http.post(
          '/api/baseline',
          {
            name: this.baselineName,
            description: this.baselineDescription,
            requirements: this.selectRequirementsOption === 'individual' ? this.selectedRequirements : [],
            select_all_requirements: this.selectRequirementsOption === 'all',
            select_from_parent_folder: this.selectRequirementsOption === 'folder',
            select_from_parent_folder_id: this.selectRequirementsOption === 'folder' && this.selectedFolder ? this.selectedFolder.folder_id : null,
            project: this.currentProject
          }
        ).then(response => {
          window.AP.flag.create({
            title: 'Success!',
            body: 'Baseline created successfully',
            type: 'success',
            close: 'auto'
          })
          this.clearModal()
          this.setTheState()
          this.$refs.createbaselinemodal.hide()
        }, error => {
          let errorString = this.createErrorStringFromResponse(error.response.data)
          window.AP.flag.create({
            title: 'Error',
            body: `There was a problem saving your baseline: ${errorString}`,
            type: 'error'
          })
          this.loading = false
        })
      },
      getRequirements () {
        this.$http.get(
          '/api/requirement?atlassian_project_id=' + this.currentProject.id
        ).then(response => {
          this.requirements = response.data.requirements
        }, response => {
          console.log('error')
        })
      },
      getPrimaryFolders () {
        this.$http.get(
          `/api/folder/primary?atlassian_project_id=${this.currentProject.id}`,
        ).then(response => {
          this.folders = response.data.folders
        }, response => {
          console.log('error')
        })
      },
      setTheState () {
        this.$store.commit('setNeedToRefreshBaselineList', true)
      }
    }
  }
</script>

<style>
  .multiselect__tag {
    max-width: 100%;
    overflow-x: hidden;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// CreateBaselineModal.vue?2d12e232